import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';
import TextField from '@material-ui/core/TextField/TextField';
import globalContext from '../../../../config/context';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 300,
  },
  comboBox: {
    width: '100%',
    paddingBottom: 10,
    disabled: 'true',
  },
  textField: {
    width: '100%',
    paddingBottom: 10,
  },
}));

const DialogBlok = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{pencarian}, {setPencarian, setAlert, setLoading}] = useAppContext();

  const {
    kecamatan,
    setKecamatan,
    kecamatanOptions,
    handleKecamatan,
    itemKecamatan,
    kelurahan,
    setKelurahan,
    kelurahanOptions,
    handleKelurahan,
    itemKelurahan,
    blok,
    setBlok,
    blokOptions,
    handleBlok,
    itemBlok,
    onCariBlok,
  } = props;

  // console.log(pencarian.kecamatan);
  // console.log(pencarian.kelurahan);

  useEffect(() => {
    if (pencarian.kecamatan) {
      setKecamatan(pencarian.kecamatan);
    }
    if (pencarian.kelurahan) {
      setKelurahan(pencarian.kelurahan);
    }
    if (pencarian.blok) {
      setBlok(pencarian.blok);
    }
  }, [pencarian.kecamatan, setKecamatan, pencarian.kelurahan, setKelurahan, pencarian.blok, setBlok]);

  return (
    <div className={classes.root}>
      <Autocomplete
        id="combo-box-kecamatan"
        className={classes.comboBox}
        options={itemKecamatan}
        getOptionLabel={(option) => (option ? option.kd_kecamatan + ' - ' + option.nm_kecamatan : '')}
        value={kecamatanOptions}
        onChange={handleKecamatan}
        renderInput={(params) => <TextField {...params} label="Kecamatan" variant="outlined" />}
      />

      <Autocomplete
        id="combo-box-kelurahan"
        className={classes.comboBox}
        disabled={kecamatan === ''}
        options={itemKelurahan}
        getOptionLabel={(option) => (option ? option.kd_kelurahan + ' - ' + option.nm_kelurahan : '')}
        value={kelurahanOptions}
        onChange={handleKelurahan}
        renderInput={(params) => <TextField {...params} label="Kelurahan" variant="outlined" />}
      />

      <Autocomplete
        id="combo-box-blok"
        className={classes.comboBox}
        disabled={kelurahan === ''}
        options={itemBlok}
        getOptionLabel={(option) => (option ? option.kd_blok : '')}
        value={blokOptions}
        onChange={handleBlok}
        renderInput={(params) => <TextField {...params} label="Blok" variant="outlined" />}
      />
    </div>
  );
};

export default DialogBlok;
